module.exports = __webpack_public_path__ + "static/media/handStrength3.75f65147.png";